import React from "react";
import "./Experience.css";
import { Card, Grid, Typography } from "@material-ui/core";
import Typical from "react-typical";

const cardData = [
  {
    title: "E-commerce website",
    picture: "e-commerce",
    detail: "Using html, css, js, boostrap, owl, and jquery.",
  },
  {
    title: "Netflix website",
    picture: "netflix",
    detail: "Using html, css, javascript, API, React JS.",
  },
  {
    title: "Portiflio website",
    picture: "portiflio",
    detail: "Using html, css, js, boostrap, owl, and jquery.",
  },
  {
    title: "Register program",
    picture: "register",
    detail: "Using php, mysql, myadmin and boostrap.",
  },
  {
    title: "IOT-webblog",
    picture: "webblog",
    detail: "Using html, css, js and boostrap.",
  },
  {
    title: "department management system",
    picture: "department",
    detail: "Using php, mysql, myadmin and boostrap.",
  },
];

function Experience() {
  return (
    <div className="experience">
      <h2 className="title">
        {" "}
        <Typical
          loop={Infinity}
          wrapper="b"
          steps={["Projects", 9000, "What I used to do", 9000]}
        ></Typical>
      </h2>
      <div className="max-width">
        <div className="Exper-content">
          <Grid container spacing={5}>
            {cardData?.map((e) => (
              <Grid item xs={12} sm={12} md={6} lg={4}>
                <Card className="cards">
                  <h3 className="cardTitle">{e.title}</h3>
                  <img src={`/image/${e.picture}.jpg`} alt="" />
                  <br />
                  <Typography className="details">{e.detail}</Typography>
                </Card>
              </Grid>
            ))}
          </Grid>
        </div>
      </div>
    </div>
  );
}

export default Experience;
